import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { MonitoringService } from '@lockton-apps/shared/util/app-monitoring';

import { FeedbackService } from '@lockton-apps/shared/ui/lui';
import { ErrorService } from './error.service';
import { HttpRequestTracker } from '@lockton-apps/shared/util/http';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private injector: Injector,
    private appMonitor: MonitoringService,
    private readonly httpRequestTracker: HttpRequestTracker
  ) {}

  handleError(error: Error | HttpErrorResponse) {
    const errorService = this.injector.get<ErrorService>(ErrorService);

    const feedbackService = this.injector.get<FeedbackService>(FeedbackService);

    // Client Error
    const message = errorService.getClientErrorMessage(error);
    // feedbackService.subtleMessage(message, { type: 'error' });
    this.appMonitor.logException(error); //todo create context here with user info

    this.httpRequestTracker.remove((error as HttpErrorResponse).url as string);
    console.error(error);
  }
}
